import { render, staticRenderFns } from "./getBackPassword.vue?vue&type=template&id=436eee9c&scoped=true"
import script from "./getBackPassword.vue?vue&type=script&lang=js"
export * from "./getBackPassword.vue?vue&type=script&lang=js"
import style0 from "./getBackPassword.vue?vue&type=style&index=0&id=436eee9c&prod&scoped=true&lang=less"
import style1 from "./getBackPassword.vue?vue&type=style&index=1&id=436eee9c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436eee9c",
  null
  
)

export default component.exports